
import { useEffect } from "react";

import { getCachedItem, setCachedItem } from "../../helpers";
import { useGetAllReportData } from "../../hooks";

export const useReportsList = ({ locationId } = {}) => {
  const cachedData = getCachedItem("reports");
  const { data, isLoading, isSuccess } = useGetAllReportData({
    enabled: !cachedData,
    defaultLocation: locationId,
  });
  const reports = cachedData || data || [];

  useEffect(() => {
    if (data && isSuccess) {
      setCachedItem("reports", data);
    }
  }, [data, isSuccess]);

  return { reports, isLoading, isSuccess };
};
